import { html, LitElement } from "lit"
import { property } from 'lit/decorators';

type CorporateStatus = null | 'expanding' | 'collapsing' | 'collapsed';

export default class RpsTogglerButton extends LitElement {

  @property()
  corporateStatus: CorporateStatus = 'collapsed';

  render() {
    return html`
        <button class="corporate-menu__toggle relative group text-white" aria-label=${this.corporateStatus === 'collapsed' ? 'Apri il menu Rai' : 'Chiudi il menu Rai'}>
          ${this.corporateStatus === 'collapsed'
            ? html`
              <img class="w-10 h-10 bg-gray-medium" alt="Logo Menu Radio Rai" src="/dl/components/img/radio/logoMenuRadio.png">
              <div class="toggle__icon hidden absolute top-0 w-10 h-10 bg-gray-medium group-hover:flex justify-center items-center">
                <svg class="h-6 w-6" viewBox="0 0 448 512"><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>
              </div>
              `
                : html`<div class="close__icon w-16 h-17 flex justify-center items-center" style="background-color:rgb(71, 83, 88)"><svg  class="h-10 w-10 fill-current"  viewBox="0 0 40 40"> <path d="M21.7,20l9.8-9.8C32,9.7,32,9,31.5,8.5C31,8,30.3,8,29.8,8.5L20,18.3l-9.8-9.8C9.7,8,9,8,8.5,8.5 C8,9,8,9.7,8.5,10.2l9.8,9.8l-9.8,9.8C8,30.3,8,31,8.5,31.5c0.2,0.2,0.6,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4l9.8-9.8l9.8,9.8 c0.2,0.2,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4c0.5-0.5,0.5-1.3,0-1.7L21.7,20z" class="st0"></path></svg></div>`
          }
        </button>
    `;
  }

  createRenderRoot(){
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rps-toggler-button': RpsTogglerButton
  }
}
